var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 30C27.7614 30 30 27.7614 30 25C30 22.2386 27.7614 20 25 20C22.2386 20 20 22.2386 20 25C20 27.7614 22.2386 30 25 30Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 25C47.5 24.2 47.4 23.4 47.2 22.6L42.8 20.8C42.4 19.6 42.8 18.2 43.8 17.4L47.2 14.6C46.8 13.8 46.2 13 45.6 12.4L42.2 15.2C41.2 14.4 39.8 14.8 39.4 16L35 17.8C34.2 17.6 33.4 17.5 32.6 17.5H32.4C32.2 16.3 31.4 15.3 30.2 15L29.8 10.4C28.8 10.2 27.8 10 26.8 10H25.2C24.2 10 23.2 10.2 22.2 10.4L21.8 15C20.6 15.3 19.8 16.3 19.6 17.5H19.4C18.6 17.5 17.8 17.6 17 17.8L12.6 16C12.2 14.8 10.8 14.4 9.8 15.2L6.4 12.4C5.8 13 5.2 13.8 4.8 14.6L8.2 17.4C9.2 18.2 9.6 19.6 9.2 20.8L4.8 22.6C4.6 23.4 4.5 24.2 4.5 25C4.5 25.8 4.6 26.6 4.8 27.4L9.2 29.2C9.6 30.4 9.2 31.8 8.2 32.6L4.8 35.4C5.2 36.2 5.8 37 6.4 37.6L9.8 34.8C10.8 35.6 12.2 35.2 12.6 34L17 32.2C17.8 32.4 18.6 32.5 19.4 32.5H19.6C19.8 33.7 20.6 34.7 21.8 35L22.2 39.6C23.2 39.8 24.2 40 25.2 40H26.8C27.8 40 28.8 39.8 29.8 39.6L30.2 35C31.4 34.7 32.2 33.7 32.4 32.5H32.6C33.4 32.5 34.2 32.4 35 32.2L39.4 34C39.8 35.2 41.2 35.6 42.2 34.8L45.6 37.6C46.2 37 46.8 36.2 47.2 35.4L43.8 32.6C44.8 31.8 45.2 30.4 44.8 29.2L47.5 27.4V25ZM25 35C18.4 35 13 29.6 13 23C13 16.4 18.4 11 25 11C31.6 11 37 16.4 37 23C37 29.6 31.6 35 25 35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.286b27403bf16f516217853b8ced3baf.svg";
export { ForwardRef as ReactComponent };